import * as _ from "lodash";
import { Field } from "./field.model";
import { Limit } from "./limit.model";

export class Plan {
    public color: string;
    public cpcountry: string;
    public cpid: number;
    public cpinterval: string;
    public cpmax: number;
    public cpname: string;
    public cpprice: number;
    public cpstatus: boolean;
    public cpstripeid: boolean;
    public cptimestamp: string;
    public planCoverage: string[];
    public planExcludes: string[];
    public limits: object;
    public userslimit: number;
    public superuserslimit: number;
    public customfieldslimit: number;
    public year: number;
    public exceededLimits: object[];

    public loading?: boolean;
    public intent?: any;

    constructor(data: any) {
        this.setData(data);
    }

    setData(data: any): void {
        if (data.features) {
            data.features = JSON.parse(data.features);
        }
        _.merge(this, data);
        this.limits = new Limit({
            customfields: this.customfieldslimit ?? null,
            superusers: this.superuserslimit ?? null,
            users: this.userslimit ?? null,
        });

        this.cpmax = parseInt(this.cpmax.toString().replace(/,/g, ""), 10);
        this.planText();
    }

    planText(): void {
        const planLimits = [`${this.number(this.cpmax)} contacts`];
        planLimits.push(`${this.number(this.customfieldslimit)} custom fields`);

        const premiumAddOns = ["Real-time field tracking", "Reporting tools"];
        const standardAddOns = [];

        if (this.cpname == "Legacy") {
            this.planCoverage = [
                "This plan will retain your account and current data with access to data management but you are unable to perform interactions.",
            ];
        } else if (this.cpname == "Starter" || this.cpname == "Basic") {
            this.planCoverage = [...planLimits];
            this.planExcludes = premiumAddOns;
        } else if (this.cpname == "Standard") {
            this.planCoverage = [...planLimits, ...standardAddOns];
            this.planExcludes = premiumAddOns;
        } else if (this.cpname == "Standard Plus") {
            this.planCoverage = [...planLimits, ...standardAddOns];
            this.planExcludes = premiumAddOns;
        } else if (this.cpname == "Pro") {
            this.planCoverage = [
                ...planLimits,
                ...standardAddOns,
                ...premiumAddOns,
            ];
        } else if (this.cpname == "Custom") {
            this.planCoverage = [...planLimits];
        }
    }

    getExceededLimits(
        customFields: Field[],
        peopleCount: number,
        usersCount: any,
        limits: Limit,
        checkUsers: boolean
    ): void {
        let exceededLimits = [];

        if (peopleCount && peopleCount > this.cpmax) {
            exceededLimits.push({
                dataType: "contacts",
                message:
                    `You cannot select this plan because your account currently has ${this.number(
                        peopleCount
                    )} ` +
                    ` contacts/houses while the selected plan only allows up to ${this.number(
                        this.cpmax
                    )}.`,
            });
        }
        if (checkUsers) {
            if (
                usersCount &&
                usersCount.superinvites +
                    usersCount.superusers -
                    limits.extrasuperusers >
                    this.superuserslimit
            ) {
                exceededLimits.push({
                    dataType: "users",
                    message:
                        "You have " +
                        this.number(
                            usersCount.superinvites +
                                usersCount.superusers -
                                limits.extrasuperusers
                        ) +
                        " super users. This has exceeded the limit on this plan of " +
                        this.number(this.superuserslimit) +
                        " super users",
                });
            }
            if (
                usersCount &&
                usersCount.invites + usersCount.users - limits.extrausers >
                    this.userslimit
            ) {
                exceededLimits.push({
                    dataType: "users",
                    message:
                        "You have " +
                        this.number(
                            usersCount.invites +
                                usersCount.users -
                                limits.extrausers
                        ) +
                        " users. This has exceeded the limit on this plan of " +
                        this.number(this.userslimit) +
                        " users",
                });
            }
        }
        if (
            customFields &&
            customFields.length - limits.extracustomfields >
                this.customfieldslimit
        ) {
            let text =
                "You currently have " +
                customFields.length +
                " custom fields. ";
            if (limits.extracustomfields > 0) {
                text +=
                    "We have already given you additional custom field allowance of " +
                    this.number(limits.extracustomfields) +
                    " custom fields.";
            }

            text +=
                "This has exceeded custom field limit on this plan  of " +
                this.number(this.customfieldslimit) +
                " custom fields";

            exceededLimits.push({
                dataType: "customFields",
                message: text,
            });
        }

        this.exceededLimits = exceededLimits;
    }

    getName(): string {
        return this.cpname == "Legacy" ? "Subscription Paused" : this.cpname;
    }

    number(x: any): string {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
}
